import { createMiddleware as createBeaconMiddleware, createMetaReducer } from 'redux-beacon';
import type { Target } from 'redux-beacon';
import GoogleTagManager from '@redux-beacon/google-tag-manager';
import eventsMap from './eventsMap';
import { getGTMTagID } from './setup';

const gmt: Target | undefined = getGTMTagID() ? GoogleTagManager() : undefined;

const middleware = gmt ? createBeaconMiddleware(eventsMap, gmt) : undefined;
const reducers = gmt ? createMetaReducer(eventsMap, gmt) : undefined;

const getGmt = () => gmt;
const getMiddleware = () => middleware;
const getReducers = () => reducers;

export default { getGmt, getMiddleware, getReducers };
